<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import TabVertical from 'comp/content/TabVertical'

import { richTextImgHandler } from '@/utils/common'
import { getSubPage } from '@/api/pageData'

export default {
  name: 'DialogId2',
  components: { ModuleTitle, TabVertical },
  props: {
    currentModule: {
      type: Object,
      default: () => {}
    },
    currentModuleItemDataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      path: this.$route.path,
      admini: localStorage.getItem('admini'),
      pageData: [],
      tabActive: 0,
      currentMemo: {}
    }
  },
  computed: {
    pageDataFilter2Tab() {
      let arr = []
      if (this.pageData) {
        this.pageData.forEach(item => arr.push({ id: item.id, title: item.headline, img: item.photo }))
      }
      return arr
    },
    pageConfig() {
      let img = ''
      let color = ''
      switch (this.currentModule.id) {
        case 28:
          img = require('imgs/modules/module-28-bg.webp')
          color = '#E57474'
          break
        case 64:
          img = require('imgs/modules/module-64-bg.webp')
          color = '#6BB4C0'
          break
        case 58:
          img = require('imgs/modules/module-58-bg.webp')
          color = '#60977C'
          break
        default:
          img = require('imgs/modules/module-28-bg.webp')
          color = '#E57474'
      }
      return [img, color]
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    richTextImgHandler,
    onTabClick(id) {
      this.pageData.forEach((item, idx) => {
        if (item.id === id) {
          this.tabActive = idx
          this.currentMemo = item
        }
      })
    },

    initPageData() {
      const params = {
        titleid: Number(this.currentModule.titleid),
        title: this.currentModule.title,
        subtitle: '',
        userid: localStorage.getItem('screenUserid') || 0,
        village: localStorage.getItem('currentCommunity') || ''
      }
      getSubPage(params).then(res => {
        if (res.code === 0) {
          this.pageData = res.msg[0].list
          // this.currentMemo = this.pageData[0]
          this.pageData.length > 0 && this.pageData.forEach((item, idx) => {
            if (item.id === this.currentModuleItemDataId) this.tabActive = idx
          })
          this.currentMemo = this.pageData[this.tabActive]
        }
      })
    }
  }
}
</script>

<template>
  <div class="dialog-id-3">
    <module-title :title="currentModule.title" margin-bottom="40" />
    <div class="main-container">
      <div
        class="left-container"
        :style="{background: `url(${pageConfig[0]}) no-repeat center`, backgroundSize: '100% 100%'}"
      >
        <div class="content">
          <p v-if="currentModule.id == 28" class="divider"><span>——</span> {{ `${admini}退役军人服务站` }} <span>——</span></p>
          <p class="item-title" :style="{backgroundColor: pageConfig[1]}">{{ currentMemo.headline }}</p>
          <p class="rich-text dialog-id-3-text" v-html="richTextImgHandler(currentMemo.memo)"></p>
        </div>
      <!-- <p class="rich-text" v-html="richTextImgHandler(currentMemo.memo)"></p> -->
      </div>
      <div class="right-container">
        <tab-vertical
          :page-data="pageDataFilter2Tab"
          :tab-active="tabActive"
          :has-img="false"
          @onTabClick="onTabClick"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.dialog-id-3 {
  .dialog-id-3-text {
    font-size: 12px !important;
    p, span, i {
      font-size: 12px !important;
      line-height: 28px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
// 1330
// .dialog-id-2 {
//   display: flex;
// }
.main-container {
  display: flex;
  position: relative;
  margin-top: 60px;
  height: 570px;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}
.left-container {
  width: 500px;
  height: 670px; // 673px
  margin-left: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // background: url('~imgs/modules/module-28-bg.webp') no-repeat center;
  // background-size: 100% 100%;
}
.right-container {
  position: fixed;
  margin-left: 910px;
}
.content {
  width: 500px;
  height: 570px;
  box-sizing: border-box;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  padding: 30px 40px 0;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
  .divider {
    width: 100%;
    text-align: center;
    font-size: 24px;
    transform: scale(.7);
    font-family: siyuansong;
    font-weight: 800;
    color: #E57474;
    // margin-top: 32px;
    span {
      padding: 0 10px;
    }
  }
  .item-title {
    min-width: 88px;
    // min-height: 50px;
    // background-color: #E57474;
    border-radius: 10px;
    font-size: 22px;
    font-family: siyuansong;
    font-weight: 800;
    color: #fff;
    padding: 8px 20px;
    box-sizing: border-box;
    display: grid;
    place-items: center;
    margin-top: 10px;
  }
  .rich-text {
    width: 410px;
    display: block;
    margin-top: 20px;
  }
}
</style>
